import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-typeahead';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core-radio-group';
import '@maersk-global/mds-components-core-radio';
import { RepairPartService } from '../../../services/repair-part.service';
import { CodeDescription } from '../../../models/code-description.model';
import { IMcTypeaheadData } from '@maersk-global/mds-components-core/mc-typeahead/types';
import { firstValueFrom } from 'rxjs';

export const GRADE_OPTIONS: string[] = ['E', 'K', 'M', 'Q', 'S'];

@Component({
  selector: 'app-container-grade-repair-code-information',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './container-grade-repair-code-information.component.html',
  styleUrls: ['./container-grade-repair-code-information.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContainerGradeRepairCodeInformationComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() isEditMode = false;

  repairCodeTypeaheadData: IMcTypeaheadData[] = [];
  repairModeList: CodeDescription[] = [];
  gradeOptions = GRADE_OPTIONS;
  isLoadingCodes = false;
  isLoadingModes = false;

  constructor(private readonly repairPartService: RepairPartService) {}

  ngOnInit(): void {
    this.initializeComponent();
  }

  private async initializeComponent(): Promise<void> {
    if (!this.isEditMode) {
      await this.loadModes();
    }
  }

  async onModeChange(event: Event): Promise<void> {
    const customEvent = event as CustomEvent;
    const selectedMode = customEvent?.detail?.value ?? customEvent?.detail;
    if (selectedMode) {
      await this.loadRepairCodes(selectedMode);
    }
  }

  private async loadRepairCodes(repairMode: string): Promise<void> {
    this.isLoadingCodes = true;
    try {
      const codes = await firstValueFrom(this.repairPartService.getAllRepairCodes(repairMode));
      this.repairCodeTypeaheadData = (codes || []).map((c) => ({
        label: c.code,
        sublabel: c.description,
        value: c.code,
      }));
    } catch {
      this.repairCodeTypeaheadData = [];
    } finally {
      this.isLoadingCodes = false;
    }
  }

  private async loadModes(): Promise<void> {
    this.isLoadingModes = true;
    try {
      const modes = await firstValueFrom(this.repairPartService.getAllRepairModes());
      this.repairModeList = modes || [];
    } catch {
      this.repairModeList = [];
    } finally {
      this.isLoadingModes = false;
    }
  }

  isControlInErrorState(control: FormControl | AbstractControl | null | undefined): boolean | null {
    if (control?.invalid && control.touched) {
      return true;
    }
    return null;
  }
}
